<template>
    <div class="container my-5">
        <div class="row">
            <div class="col-12 search-tips-col" v-html="getSetting(type)"/>
        </div>
    </div>
</template>

<style lang="scss">
    .search-tips-col{
        background-color: #024659;
        padding-top: 0.7rem;
        padding-bottom: 0.3rem;

        p{
            margin-bottom: 0.4rem;
            text-align: center;
            color: #fff;
        }
    }
</style>

<script>
    import {mapGetters} from 'vuex';

    export default {
        props: {
            type: {
                type: String,
                required: true,
            },
        },

        computed: {
            ...mapGetters({
                getSetting: 'constants/getSetting',
            }),
        },
    };
</script>
